module.exports = __webpack_public_path__ + "kn.8619b7227c146f936971.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/kn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/kn.svg
// module chunks = styles